import { Column } from "primereact/column"
import { ColumnGroup } from "primereact/columngroup"
import { Row } from "primereact/row"

export type LineValuesColumnsPattern = {
    reverseLines: any[],
    forwardLines: any[]
}

export type SideLineValuesColumnsPattern = {
    reverseLines: any[],
    forwardLines: any[],
    sides: any[]
}

export function LineValuesHeaderColumnGroupTemplate({ reverseLines, forwardLines }: LineValuesColumnsPattern) {
    const reverseLineCount = reverseLines.length
    const forwardLineCount = forwardLines.length
    return (
        <ColumnGroup>
            <Row>
                <Column header="Местоположение" colSpan={2} align="center" />
                {reverseLineCount > 0 &&
                    <Column header="Обратное направление" colSpan={reverseLineCount} align="center" />
                }
                {forwardLineCount > 0 &&
                    <Column header="Прямое направление" colSpan={forwardLineCount} align="center" />
                }
            </Row>
            <Row>
                <Column header="Км" colSpan={1} rowSpan={1} align="center" sortable field="Position" />
                <Column header="Км+" colSpan={1} rowSpan={1} align="center" sortable field="MaintenancePosition" />
                {reverseLines.map((line: any, index: number) =>
                    <Column header={index + 1} colSpan={1} align="center" sortable field={`${line}Value`} />
                )}
                {forwardLines.map((line: any, index: number) =>
                    <Column header={reverseLineCount + index + 1} colSpan={1} align="center" sortable field={`${line}Value`} />)
                }
            </Row>
        </ColumnGroup>
    )
}

export function SideLineValuesHeaderColumnGroupTemplate({ reverseLines, forwardLines, sides }: SideLineValuesColumnsPattern) {
    const reverseLineCount = reverseLines.length
    const forwardLineCount = forwardLines.length
    return (
        <ColumnGroup>
            <Row>
                <Column header="Местоположение" colSpan={2} align="center" />
                {reverseLineCount > 0 &&
                    <Column header="Обратное направление" colSpan={reverseLineCount * 2} align="center" />
                }
                {forwardLineCount > 0 &&
                    <Column header="Прямое направление" colSpan={forwardLineCount * 2} align="center" />
                }
            </Row>
            <Row>
                <Column header="Км" colSpan={1} rowSpan={2} align="center" sortable field="Position" />
                <Column header="Км+" colSpan={1} rowSpan={2} align="center" sortable field="MaintenancePosition" />
                {reverseLines.map((_, index) =>
                    <Column header={index + 1} colSpan={2} align="center" />
                )}
                {forwardLines.map((_, index) =>
                    <Column header={reverseLineCount + index + 1} colSpan={2} align="center" />
                )}
            </Row>
            <Row>
                {sides.map((side: any) =>
                    <Column header={side.headerName} colSpan={1} align="center" sortable field={side.field} />
                )}
            </Row>
        </ColumnGroup>
    )
}